"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var summaryTitleStyles_1 = require("./summaryTitleStyles");
var SummaryTitle = function (_a) {
    var style = summaryTitleStyles_1.default();
    return (<core_1.Box className={style.title}>
      <core_1.Typography className={style.name}>
        <Translation_1.default id={'label.mySummary'}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = SummaryTitle;
